// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface PriceUOMComponentStyles {
    priceWrapper?: InjectableCss;
    priceText?: InjectableCss;
    unitOfMeasureText?: InjectableCss;
}

export const PriceUOMComponentStyles: PriceUOMComponentStyles = {
    priceWrapper: {
        css: css`
            display: flex;
            align-items: center;
            flex-wrap: wrap;
        `,
    },
    priceText: {},
    unitOfMeasureText: {
        css: css`
            margin-right: 8px;
        `,
    },
};

const PriceUOMComponent: React.FC<any> = ({ pricing, showUnit, extendedStyles }: any) => {
    let priceUOM;
    let priceUOMNetPrice;
    if (pricing && pricing.additionalResults) {
        priceUOM = pricing.additionalResults.priceUOM;
        priceUOMNetPrice = pricing.additionalResults.priceUOMNetPrice;
    }
    const styles = mergeToNew(PriceUOMComponentStyles, extendedStyles);
    return (
        <StyledWrapper {...styles.priceWrapper}>
            {priceUOMNetPrice && (
                <Typography {...styles.priceText} data-test-selector="productPrice_UOMNetPrice" itemProp="price">
                    {priceUOMNetPrice}
                </Typography>
            )}
            {showUnit && priceUOM && priceUOMNetPrice && (
                <Typography {...styles.unitOfMeasureText} data-test-selector="productPrice_UOMLabel">
                    &nbsp;/&nbsp;{priceUOM}
                </Typography>
            )}
        </StyledWrapper>
    );
};

PriceUOMComponent.defaultProps = {
    showUnit: true,
};

export default PriceUOMComponent;
